import { TimeZone } from "@vvo/tzdb";

export function getOffsetHoursFromIANATimezone(timezone: TimeZone): number {
  return Math.round((timezone.currentTimeOffsetInMinutes / 60) * 100) / 100;
}

export default getOffsetHoursFromIANATimezone;
